import { render, staticRenderFns } from "./cosItemForm.vue?vue&type=template&id=35a95617&scoped=true"
import script from "./cosItemForm.vue?vue&type=script&lang=js"
export * from "./cosItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a95617",
  null
  
)

export default component.exports